import * as Types from '../types';
import { Environment } from 'config';
import request from 'utils/request';
import { LanguagesEnum } from 'constants/languages';
import { varToStringParams } from 'utils/path';

/** fetchSpecificationAttributeList  */
export interface ISpecificationAttributeListOutput {
  items: IDataItems[];
  paging: IPaging;
}

export interface IDataItems {
  id: number;
  name: string;
  names: {
    language: LanguagesEnum;
    value: string;
  }[];
  systemname: string;
  displayorder: number;
  storeid: number;
  type: number;
  filtering: boolean;
  icon?: string | null;
  iconcolor?: string | null;
  picture?: string | null;
  iconId?: number | null;
  pictureId?: number | null;
  prefix: string | null;
  tags?: { id: number; name: string }[];
  options?: {
    displayorder: number;
    id: number;
    name: string;
    specificationattributeid: number;
  }[];
}

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

export interface ISpecificationAttributeListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  name: string;
  language: LanguagesEnum;
  is_amentities: boolean;
  category?: string;
}

export const fetchSpecificationAttributeList = async (
  payload: ISpecificationAttributeListInput
): Promise<Types.ResponseOutput> => {
  let query = varToStringParams({
    variablesArray: [
      { key: 'page', value: payload.page?.toString() },
      { key: 'pageSize', value: payload.pageSize?.toString() },
      { key: 'sortField', value: payload.sortField },
      { key: 'order', value: payload?.order?.toUpperCase() },
      { key: 'name', value: payload?.name },
      { key: 'language', value: payload?.language },
      { key: 'is_amentities', value: payload?.is_amentities },
      { key: 'category', value: payload?.category },
    ],
  });
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/specificationattribute/list${query}`
  );

  let _data: ISpecificationAttributeListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

/** fetchSpecificationAttributeList All  */

export const fetchSpecificationAttributeListAll = async (
  language: LanguagesEnum,
  is_amentities = true,
  category = 'Product'
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/specificationattribute/list?pageSize=9999999&language=${language}&is_amentities=${is_amentities}&category=${category}`
  );

  let _data: ISpecificationAttributeListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

/** SpecificationAttribute Detail */
interface ISpecificationAttributeDetailInput {
  id: number;
}

interface ISpecificationAttributeDetailOutput extends Types.ResponseOutput {
  data: {
    id: number | null;
    name: string | null;
    systemname: string | null;
    displayorder: number | null;
    storeid: number | null;
  };
}

export const fetchSpecificationAttributeDetail = async (
  payload: ISpecificationAttributeDetailInput
): Promise<ISpecificationAttributeDetailOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/specificationattribute/${payload.id}`
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

/** Add SpecificationAttribute */
export interface ISpecificationAttributeAddInput {
  name: string | null;
  systemname?: string | null;
  displayorder?: number | null;
  storeid?: number | null;
  category?: 'Product' | 'Customer';
}

interface ISpecificationAttributeAddOutput extends Types.ResponseOutput {
  data: {};
}

export const addSpecificationAttribute = async (
  payload: ISpecificationAttributeAddInput
): Promise<ISpecificationAttributeAddOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/specificationattribute `,
    {
      body: payload,
    }
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

/** Edit SpecificationAttribute */

interface ISpecDisplay {
  icon: number;
  picture: number;
  prefix: string;
  iconcolor: string;
}
export interface ISpecificationAttributeEditInput {
  id: number;
  name: { language: LanguagesEnum | null; value: string | null }[];
  // systemname: string | null;
  displayorder: number | null;
  type: number;
  filtering: number;
  specDisplay?: ISpecDisplay;
  tags?: { id: number; name: string }[];
}

interface ISpecificationAttributeEditOutput extends Types.ResponseOutput {
  data: {};
}

export const editSpecificationAttribute = async (
  payload: ISpecificationAttributeEditInput
): Promise<ISpecificationAttributeEditOutput> => {
  const { data }: any = await request(
    'patch',
    `${Environment.API_BASE_URL}/api/specificationattribute `,
    {
      body: payload,
    }
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

// Delete Specification Attribute

export const deleteSpecificationAttribute = async ({
  id,
}: {
  id: number;
}): Promise<ISpecificationAttributeAddOutput> => {
  const { data }: any = await request(
    'delete',
    `${Environment.API_BASE_URL}/api/specificationattribute/${id}`
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

export interface ICustomSpecificationAttribute {
  id: number;
  name: string;
  type: number;
  typeName: string;
  filtering: boolean;
  systemname: string;
  title: string;
}

export interface ICustomFilteredSpecsOutput extends Types.ResponseOutput {
  data: Array<ICustomSpecificationAttribute>;
}

export const getCustomFilteredSpecs = async (
  lan: LanguagesEnum
): Promise<ICustomFilteredSpecsOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/specificationattribute/custom-filtered/${lan}`
  );

  const _data: ICustomFilteredSpecsOutput['data'] = data.data;
  let output = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
